import { InvoiceProductItem } from '../../../../models/invoice-product-item';
import { ItemsArrayHelper } from '../components/detail-positions-table-container';
import { getHighestId } from './get-highest-id';
import { getLastPosition } from './get-last-position';

/**
 * Copy of an existing position, appended at the end of the document.
 *
 * The price is carried over untouched. A position that is already part of a credit
 * note holds a negative price, so applying the credit sign again — as the code path
 * for a freshly picked product has to — would turn the copy positive.
 */
export const getDuplicatedProductItem = (productItem: InvoiceProductItem, helper: ItemsArrayHelper) =>
    InvoiceProductItem.fromPlainObject({
        ...productItem,
        id: getHighestId(helper) + 1,
        position: helper.form.values.allItems.length === 0 ? 0 : getLastPosition(helper) + 1,
    });
